// extracted by mini-css-extract-plugin
export default {"Loading":"ComponentSummaries_Loading__exU7w"};